/* eslint-disable camelcase */
import React from 'react';
import { classes } from '../../../lib';
import Styles from './BlogPage.module.less';
import { Await } from '../../../components/Await';
import { SanityBlock, useSanity } from '../../../lib/landingPage';
import { observer } from 'mobx-react-lite';
import { Image } from '../Image';
import { Footer } from '../Footer';
import { BlogPost } from '../BlogPost';
import { Redirect, useRouteMatch } from 'react-router-dom';
import { BlogPostCategory } from '../../../components/landingPage/BlogPost';
import { Header } from '../Header';
import { categoriesQuery } from './BlogHomePage';
import { BlogSubmenu } from '../BlogSubmenu';
import routes from '../../../pages/landingPage/routes';
import { FooterBanner } from '../../../components/landingPage/FooterBanner';
import { SanityBlogPost } from '../BlogPost/types';

export type SanityBlogPostFooter = {
    Content: SanityBlock;
};

const BlogPostPageResolved = observer(
    ({
        post,
        footer,
        categories,
    }: {
        post: SanityBlogPost;
        footer: SanityBlogPostFooter;
        categories: BlogPostCategory[];
    }) => {
        const signUpUtmParam = {
            utm_source: 'blog',
            utm_campaign: post.url,
            utm_medium: 'button',
            utm_content: 'signup-header-button-clicked',
        };
        const loginUtmParam = {
            utm_source: 'blog',
            utm_campaign: post.url,
            utm_medium: 'button',
            utm_content: 'login-header-button-clicked',
        };
        return (
            <>
                <Header
                    showSignupButton
                    signUpUtmParam={signUpUtmParam}
                    loginUtmParam={loginUtmParam}
                />
                <BlogSubmenu categories={categories} />
                <div className={classes(Styles.banner, 'vertical g8')}>
                    <Image value={{ ...post.imageRef, dataset: 'blog' }} />
                </div>
                <div
                    className={classes(
                        Styles.mainContainer,
                        Styles.container,
                        Styles.containerWithSidebar,
                        'vertical between-middle mt-px16 mt-py24 mt-g24 d-px32 d-py48 d-g48'
                    )}>
                    <BlogPost post={post} footer={footer} />
                </div>
                {post.footerBanner && <FooterBanner {...post.footerBanner} />}
                <Footer hideMenu={false} />
            </>
        );
    }
);

export const BlogPostPage = observer(() => {
    const sanity = useSanity();
    const match = useRouteMatch<{ postSlug: string }>({
        path: routes.blog.post.path,
    });
    const postSlug = match?.params.postSlug;
    if (!postSlug) return <Redirect to={'/'} />;
    return (
        <Await
            views={{
                post: sanity.asyncBlogPost(postSlug),
                footer: sanity.asyncBlogPostFooter(),
                categories: sanity.asyncBlog(categoriesQuery),
            }}
            resolved={BlogPostPageResolved}
        />
    );
});
